import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { TextFormat, Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './product-process-history.reducer';

export const ProductProcessHistoryDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const productProcessHistoryEntity = useAppSelector(state => state.productProcessHistory.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="productProcessHistoryDetailsHeading">
          <Translate contentKey="crawlerBackendApp.productProcessHistory.detail.title">ProductProcessHistory</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{productProcessHistoryEntity.id}</dd>
          <dt>
            <span id="processType">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.processType">Process Type</Translate>
            </span>
          </dt>
          <dd>{productProcessHistoryEntity.processType}</dd>
          <dt>
            <span id="stepType">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.stepType">Step Type</Translate>
            </span>
          </dt>
          <dd>{productProcessHistoryEntity.stepType}</dd>
          <dt>
            <span id="stepStatus">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.stepStatus">Step Status</Translate>
            </span>
          </dt>
          <dd>{productProcessHistoryEntity.stepStatus}</dd>
          <dt>
            <span id="retryCount">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.retryCount">Retry Count</Translate>
            </span>
          </dt>
          <dd>{productProcessHistoryEntity.retryCount}</dd>
          <dt>
            <span id="payloadIn">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.payloadIn">Payload In</Translate>
            </span>
          </dt>
          <dd>{productProcessHistoryEntity.payloadIn}</dd>
          <dt>
            <span id="payloadOut">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.payloadOut">Payload Out</Translate>
            </span>
          </dt>
          <dd>{productProcessHistoryEntity.payloadOut}</dd>
          <dt>
            <span id="coolingOffEnd">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.coolingOffEnd">Cooling Off End</Translate>
            </span>
          </dt>
          <dd>
            {productProcessHistoryEntity.coolingOffEnd ? (
              <TextFormat
                value={productProcessHistoryEntity.coolingOffEnd}
                type="date"
                format={APP_LOCAL_DATE_FORMAT}
              />
            ) : null}
          </dd>
          <dt>
            <span id="offerExpirationDate">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.offerExpirationDate">
                Offer Expiration Date
              </Translate>
            </span>
          </dt>
          <dd>
            {productProcessHistoryEntity.offerExpirationDate ? (
              <TextFormat
                value={productProcessHistoryEntity.offerExpirationDate}
                type="date"
                format={APP_LOCAL_DATE_FORMAT}
              />
            ) : null}
          </dd>
          <dt>
            <span id="mandateSignedDate">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.mandateSignedDate">
                Mandate Signed Date
              </Translate>
            </span>
          </dt>
          <dd>
            {productProcessHistoryEntity.mandateSignedDate ? (
              <TextFormat
                value={productProcessHistoryEntity.mandateSignedDate}
                type="date"
                format={APP_LOCAL_DATE_FORMAT}
              />
            ) : null}
          </dd>
          <dt>
            <span id="desiredDate">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.desiredDate">Desired Date</Translate>
            </span>
          </dt>
          <dd>
            {productProcessHistoryEntity.desiredDate ? (
              <TextFormat value={productProcessHistoryEntity.desiredDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <span id="actualStartDate">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.actualStartDate">
                Actual Start Date
              </Translate>
            </span>
          </dt>
          <dd>
            {productProcessHistoryEntity.actualStartDate ? (
              <TextFormat
                value={productProcessHistoryEntity.actualStartDate}
                type="date"
                format={APP_LOCAL_DATE_FORMAT}
              />
            ) : null}
          </dd>
          <dt>
            <span id="transactionId">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.transactionId">Transaction Id</Translate>
            </span>
          </dt>
          <dd>{productProcessHistoryEntity.transactionId}</dd>
          <dt>
            <span id="waiveCoolingOffRight">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.waiveCoolingOffRight">
                Waive Cooling Off Right
              </Translate>
            </span>
          </dt>
          <dd>{productProcessHistoryEntity.waiveCoolingOffRight ? 'true' : 'false'}</dd>
          <dt>
            <span id="depositRequired">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.depositRequired">
                Deposit Required
              </Translate>
            </span>
          </dt>
          <dd>{productProcessHistoryEntity.depositRequired ? 'true' : 'false'}</dd>
          <dt>
            <span id="deposit">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.deposit">Deposit</Translate>
            </span>
          </dt>
          <dd>{productProcessHistoryEntity.deposit ? 'true' : 'false'}</dd>
          <dt>
            <span id="createdAt">
              <Translate contentKey="crawlerBackendApp.productProcessHistory.createdAt">Created At</Translate>
            </span>
          </dt>
          <dd>
            {productProcessHistoryEntity.createdAt ? (
              <TextFormat value={productProcessHistoryEntity.createdAt} type="date" format={APP_DATE_FORMAT} />
            ) : null}
          </dd>
          <dt>
            <Translate contentKey="crawlerBackendApp.productProcessHistory.productProcess">Product Process</Translate>
          </dt>
          <dd>{productProcessHistoryEntity.productProcess ? productProcessHistoryEntity.productProcess.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/product-process-history" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button
          tag={Link}
          to={`/product-process-history/${productProcessHistoryEntity.id}/edit`}
          replace
          color="primary"
        >
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default ProductProcessHistoryDetail;
